import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';
import DoctorBatchModifyPage from 'src/components/views/Doctor/DoctorBatchModifyPage';

const mapStateToProps = ({ drugStoreState: { drugStores }, userState: {isAgent, userInfo}}: IStoreState) => ({
  drugStoreList: drugStores,
  userInfo,
  isAgent,
});
const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DoctorBatchModifyPage);



// WEBPACK FOOTER //
// ./src/containers/DoctorBatchModify.ts